import { Box, Typography } from "@mui/material";
import { FC } from "react";

// TODO: ローディングステータスは不要なので削除する
export enum ProgressStatus {
  start = "START",
  userScaned = "USER_SCANED",
  bloodPressureScaned = "BLOOD_PRESSURE_SCANED",
}

interface ProgressBarProps {
  status: ProgressStatus;
}

const COLORS = {
  default: "#B0B0B0",
  done: "#005BBB",
};

// TODO: 全体的にリファクタリング
export const ProgressBar: FC<ProgressBarProps> = (props) => {
  const { status } = props;
  return (
    <>
      <Box
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
        }}
      >
        <Box
          style={{
            width: "20%",
            height: "50px",
            backgroundColor: "#005BBB", // 読み取り、ロード中、血圧結果のときは青色で表示
            margin: "10px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
          }}
        >
          <Typography
            variant="h6"
            style={{ color: "white", fontSize: "0.875rem" }}
          >
            社員用QRコード読み取り
          </Typography>
          <Box
            style={{
              position: "absolute",
              top: "50%",
              right: "-20px",
              width: "20px",
              height: "4px",
              backgroundColor:
                status === ProgressStatus.start ? COLORS.default : COLORS.done,
            }}
          />
        </Box>
        <Box
          style={{
            width: "20%",
            height: "50px",
            // 血圧読み取り、ロード中、血圧結果のときは青色で表示
            backgroundColor:
              status === ProgressStatus.userScaned ||
              status === ProgressStatus.bloodPressureScaned
                ? "#005BBB"
                : "#ffffff",
            margin: "10px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
            border: "1px solid #000",
          }}
        >
          <Typography
            variant="h6"
            style={{
              color:
                status === ProgressStatus.userScaned ||
                status === ProgressStatus.bloodPressureScaned
                  ? "white"
                  : "black",
              fontSize: "0.875rem",
            }}
          >
            血圧測定用QRコード
            <br />
            読み取り
          </Typography>
        </Box>
        <Box
          style={{
            width: "20%",
            height: "50px",
            margin: "10px",
            display: "flex",
            alignItems: "center",
            backgroundColor:
              status === ProgressStatus.bloodPressureScaned
                ? "#005BBB"
                : "#ffffff",
            justifyContent: "center",
            position: "relative",
            border: "1px solid #000",
          }}
        >
          <Typography
            variant="h6"
            style={{
              color:
                status === ProgressStatus.bloodPressureScaned
                  ? "white"
                  : "black",
              fontSize: "0.875rem",
            }}
          >
            結果画面
          </Typography>
          <Box
            style={{
              position: "absolute",
              top: "50%",
              left: "-20px",
              width: "20px",
              height: "4px",
              backgroundColor:
                status === ProgressStatus.bloodPressureScaned
                  ? COLORS.done
                  : COLORS.default,
            }}
          />
        </Box>
      </Box>
    </>
  );
};
